module.exports = __webpack_public_path__ + "static/media/progress_bar.de0f2109.gif";